import { useEffect, useState } from 'react';
import { InputText, IconTrash } from '@ui/src';
import { EntityPositionsFormValues } from '../../hoc/types';
import { PositionEntityTypes } from './types';

import cn from './blacklist.module.css';

const PositionEntity = ({
  position,
  setPositions,
  positions,
  id,
}: PositionEntityTypes) => {
  const [values, setValues] = useState<EntityPositionsFormValues>();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValues = { ...values };

    if (e.target.name === `position-${id}`) {
      nextValues.position = e.target.value;
    }

    setValues(nextValues as EntityPositionsFormValues);

    if (positions) {
      const nextPositions = positions?.map((item) => {
        let result = { ...item };

        if (result.id === position?.id) {
          result = nextValues as EntityPositionsFormValues;
        }

        return result;
      });

      setPositions(nextPositions);
    }
  };

  useEffect(() => {
    if (position) {
      setValues(position);
    }
  }, [position]);

  return (
    <div className={cn.positionWrapper}>
      <div className={cn.positionInput}>
        <InputText
          name={`position-${id}`}
          value={values?.position}
          placeholder="Enter position name"
          onChange={onChange}
          title="Position name"
        />
      </div>

      <button
        type="button"
        className={cn.deletePositionButton}
        onClick={() => {
          setPositions(
            positions?.filter(
              (item) => item.id !== id,
            ) as EntityPositionsFormValues[],
          );
        }}
      >
        <IconTrash />
      </button>
    </div>
  );
};

export default PositionEntity;
